
export class DriverWithGrid {
    constructor(public index: number, public drivers: any[]){}
}